// extracted by mini-css-extract-plugin
module.exports = {"keyWordBox":"index_keyWordBox__Q07oU","keyWords":"index_keyWords__jM81C","keyWordItem":"index_keyWordItem__myQUS"};